/**
 *  @class
 *  @function Timeline
 */


if (!customElements.get('time-line')) {
  class Timeline extends HTMLElement {
    constructor() {
      super();
      this.id = this.dataset.id;
      this.scroller = this.querySelector('.timeline--scroll-container');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.scrollSet = false;
      this.items = this.querySelectorAll('.timeline--slide');
      this.labels = this.querySelectorAll('.timeline--scroll-pagination li');

      // if (this.animations_enabled) {
      //   this.scrollSet = gsap.quickSetter('#time-line-progress-' + this.id, "scaleX");
      // }


    }


    connectedCallback() {
      const _this = this;
      if (this.animations_enabled) {
        _this.scroller.addEventListener('scroll', () => this.onScroll());
      }

      _this.labels.forEach((item, i) => {
        _this.setLabelPosition(item);
      });

      // var stepper = 0;

      // Funktion zum automatischen Weiterspringen der Timeline
      // function autoScrollTimeline() {
      //   stepper++;
        
      //   let scrollContent = document.querySelector('.timeline--scroll-inner'); // Scrollbereich Element
      //   let scrollContainer = document.querySelector('.timeline--scroll-container'); // Container 
      //   let contentWidth = scrollContent.offsetWidth; // Gesamter Scrollbereich (Breite in px)
      //   let containerWidth = scrollContainer.offsetWidth; // Container (Breite in px)
      //   let label_width = document.querySelector('.timeline--slide').offsetWidth; // Breite eines Eintrags (in px)
      //   let labels = _this.labels.length; // Anzahl Einträge
        
      //   const computedStyles = window.getComputedStyle(scrollContent);
      //   const gridGap = computedStyles.getPropertyValue('grid-gap'); // Abstand zwischen Einträgen
      //   var gridGapValue = parseInt(gridGap, 10);
      //   var targetScroll = (label_width * stepper) + (gridGapValue * stepper * 0.8);
        
      //   if (stepper > labels) {
      //     stepper = 0;
      //     targetScroll = 0;
      //   }

      //   // Animation zum Weiterspringen der Timeline
      //   _this.scroller.scrollTo({
      //     left: targetScroll,
      //     behavior: 'smooth'
      //   });
      // }

      // Interval zum automatischen Weiterspringen
      // setInterval(autoScrollTimeline, 5000);

      // Labels als Buttons um zur Zeit zu springen
      setClickEvents();

      function setClickEvents() {
        const timeLinks = document.querySelectorAll('.timeline--scroll-pagination li');
  
        for (var i = 0; i < timeLinks.length; i++) {
            console.log(timeLinks[i]);
            timeLinks[i].addEventListener("click", timeLinkClick);
            timeLinks[i].setAttribute("slide-no", i);
        }
      }

      function timeLinkClick(e) {
        console.log("click");
        console.log(e);

        var slideNo = this.getAttribute("slide-no");

        let label_width = document.querySelector('.timeline--slide').offsetWidth; // Breite eines Eintrags (in px)
        let scrollContent = document.querySelector('.timeline--scroll-inner'); // Scrollbereich Element
        const computedStyles = window.getComputedStyle(scrollContent);
        const gridGap = computedStyles.getPropertyValue('grid-gap'); // Abstand zwischen Einträgen
        var gridGapValue = parseInt(gridGap, 10);
        var targetScroll = (label_width * slideNo) + (gridGapValue * slideNo * 0.8);
        
        _this.scroller.scrollTo({
          left: targetScroll,
          behavior: 'smooth'
        });

        this.scrollSet = gsap.quickSetter('#time-line-progress-' + this.id, "scaleX");
      }
      
    }

    setLabelPosition(item) {
      let contentWidth = this.scroller.querySelector('.timeline--scroll-inner').offsetWidth,
        arr = Array.prototype.slice.call(this.labels),
        i = arr.indexOf(item),
        itemWidth = this.items[i].offsetWidth;

      item.style.flex = (itemWidth / contentWidth);
    }

    onScroll() {
      let scrollLeft = this.scroller.scrollLeft,
        scrollerWidth = this.scroller.offsetWidth,
        contentWidth = this.scroller.querySelector('.timeline--scroll-inner').offsetWidth,
        scrollPercent = (scrollLeft) / (contentWidth - scrollerWidth);

      this.scrollSet(scrollPercent);
    }
  }
  customElements.define('time-line', Timeline);
}
